<script>
	export default {
		props: {
			src: { type: [Boolean, Object], default: false },
    	conector: { type: String, required: true },
		},
		data() {
			return {
				moneda: this.src.moneda,
				monedas: [
					{ id: "USD", text: "Dolar Estadounidense" },
					{ id: "ARS", text: "Peso Argentino" },
					{ id: "EUR", text: "Euro" }
				]
			};
		},
		computed: {
			tarifa() {
				return this.moneda && this.src
					? this.src.rules[this.moneda]
					: false;
			}
		}
	};
</script>

<template>
	<div>
		<div class="panel panel-default desglose" v-if="src">
			<div class="panel-body">
				<div class="input-group input-group-sm">
					<div class="input-group-addon">
						<i class="fa fa-money"></i>
					</div>
					<select class="form-control" v-model="moneda">
						<option v-for="item in monedas" :key="item.id" :value="item.id" v-text="item.text"></option>
					</select>
				</div>
			</div>

			<table class="table table-condensed">
				<thead>
					<tr class="active">
						<th>Concepto</th>
						<th colspan="2" class="text-center">Monto</th>
					</tr>
				</thead>

				<tbody class="desglose">
					<tr v-for="(item, key) in tarifa.desglose" :key="key" :class="item.class">
						<th class="concepto" v-text="item.nombre"></th>
						<td class="moneda" v-text="item.moneda"></td>
						<td class="monto" v-text="item.monto"></td>
					</tr>
				</tbody>

				<tfoot>
					<tr>
						<th>{{ conector === 'SPT' ? 'Total a abonar' : 'TOTAL' }}</th>
						<th class="moneda" v-text="moneda"></th>
						<th class="monto" v-text="tarifa.total"></th>
					</tr>
				</tfoot>
			</table>
		</div>
	</div>
</template>

<style scoped>

	.desglose {font-size: 14px; border: 0; box-shadow: 0 1px 2px rgba(0,0,0,.2);}

	.desglose > .table thead tr th,
	.desglose > .table thead tr td {border-bottom: 0; padding: 10px 10px;}


	.desglose > .table tbody tr:first-child th,
	.desglose > .table tbody tr:first-child td {border-top: 0;}

	.desglose > .table tbody tr td,
	.desglose > .table tbody tr th {padding: 10px 10px;}
	
	.desglose > .table tbody tr td.monto,
	.desglose > .table tfoot tr th.monto {font-family: Consolas, monospace;text-align: center;width: 1%;}

	.desglose > .table tbody tr td.moneda,
	.desglose > .table tfoot tr th.moneda {font-family: Consolas, monospace;text-align: center;width: 40px;}

	.desglose > .table tbody tr.item td.concepto {font-weight: 600;}
	.desglose > .table tbody tr.rule td.concepto {font-size: 11px;}

	.desglose > .table tbody tr.item th,
	.desglose > .table tbody tr.item td {font-size: 13px; font-weight: 300; color: #0c5460; background-color: #d1ecf1; border-color: #bee5eb;}

	.desglose > .table tbody tr.subt th,
	.desglose > .table tbody tr.subt td {font-size: 13px; font-weight: 600;color: #004085; background-color: #cce5ff; border-top: 1px dashed  #7ea6d1;}

	.desglose > .table tbody tr.rule th,
	.desglose > .table tbody tr.rule td {font-size: 10px; font-weight: 100; color: #856404; background-color: #fff3cd; border-top: 1px dashed  #f3d888;}

	.desglose > .table tbody tr.rule td.monto {font-size: 11px;}

	.desglose > .table tbody tr.sub_total th,
	.desglose > .table tbody tr.sub_total td {font-size: 13px; font-weight: 600;color: #004085; background-color: #cce5ff; border-top: 1px dashed  #7ea6d1;}

	.desglose > .table tbody tr.forma th, 
	.desglose > .table tbody tr.forma td {color: #0c5460;background-color: #d1ecf1; border-top: 1px dashed  #bee5eb;}

	.desglose > .table tbody tr.forma th.concepto {font-size: 13px; font-weight: 600;}

	.desglose > .table tbody tr.forma th.concepto small {display: block;font-weight: normal;font-size: 10px;}

	.desglose > .table tfoot tr td,
	.desglose > .table tfoot tr th {padding: 10px 10px; color: #155724; background-color: #d4edda; vertical-align: middle;border-top: 1px dashed #155724;}

</style>